<template>
  <main>
    <van-nav-bar @click-left="backOrder" title="提交订单" left-arrow />
    <van-steps :active="active" active-color="#ED1B23">
      <van-step>订单确认</van-step>
      <van-step>订单支付</van-step>
      <van-step v-if="isrefund">订单退款</van-step>
      <van-step v-if="!isrefund">申请开票</van-step>
      <van-step v-if="!isrefund">开票成功</van-step>
    </van-steps>
    <!-- <div style="margin-top: 20px">
      <div
        class="van-cell van-cell--center van-cell--borderless van-contact-card van-contact-card--edit">
        <i class="van-icon van-icon-contact van-cell__left-icon"></i>
        <div
          class="van-cell__value van-cell__value--alone van-contact-card__value"
        >
          <div>企业名称:{{ orders.corpName }}</div>
          <div>企业税号:{{ orders.corpNsrsbh }}</div>
        </div>
      </div>
    </div> -->

    <div
      style="background-color: #fff"
      v-for="item2 in orderInfo"
      :key="item2.id"
    >
      <van-card
        :desc="item2.spContext"
        :title="item2.spName"
        :thumb="item2.img"
      >
        <template #price>
          <span>单价：￥{{item2.je}}</span>
        </template>
        <template #num>
          <span>数量：x{{item2.count}}</span>
        </template>
        <template #footer >
          <div style="font-size: 20px"> 总价:￥{{ orders.orderZje }}</div>
        </template>
      </van-card>
    </div>

    <van-cell-group style="margin-top: 20px">
      <van-cell title="订单详情" />
      <van-cell title="订单编号" :value="orders.orderCode" />
      <van-cell title="创建时间" :value="orders.addDate" />
      <van-cell title="商户名称" :value="orders.customerName" />
      <van-cell title="商户电话" :value="orders.customerPhone" />
      <van-cell
        title="支付方式"
        :value="parseOrderPaytype(orders.orderPaytype)"
      />
      <van-cell title="开票抬头" :value="orders.corpName">
      </van-cell>
      <van-cell title="开票税号" :value="orders.corpNsrsbh">
      </van-cell>
      <van-cell title="推送邮箱" :value="orders.email">
      </van-cell>

      <van-cell title="开票信息" :value="orders.invoicingResults">
      </van-cell>

    </van-cell-group>

  

    

  </main>
</template>


<script>
import {
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  ContactCard,
  NavBar,
  Picker,
  Popup,
  Step,
   Field,
 
  Steps,
  SubmitBar,
  Tabbar,
  TabbarItem,
  Toast,
  Dialog
} from "vant";

export default {
  components: {
    [ContactCard.name]: ContactCard,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Field.name]:Field,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      linkUrl:'',
      active: 0,
      phone:'',
      mail:'',
      orderInfo: [],
      orders: [],
      htCode: "",
      isContract: "0",
      isrefund: false,
    };
  },
  methods: {
  
    toPhone(item) {
      window.location.href = "tel://" + item;
    },
    backOrder() {
      this.$router.push("/order");
    },
    parseOrderPaytype(orderPaytype) {
      let resultStr = "";

      switch (orderPaytype) {
        case "1":
          resultStr = "二维码付款";
          break;

        case "2":
          resultStr = "扫码付款";
          break;

        case "3":
          resultStr = "现金支付";
          break;
      }
      return resultStr;
    },
  },
  created() {
    let id = this.$route.query.id; //查询订单Id

    var url = "/memberBusiness/order/" + id + "/ordersList";
    this.$axios.get(url).then((data) => {
      this.orders = data.data.orders;
      console.log(this.orders)
      this.orderInfo = data.data.orderQueries;
      console.log("orderInfo");
      console.log(this.orderInfo);
      this.isContract = data.data.isContract === "1" ? "1" : "0";
      // this.fpdm = data.data.fpdm;
      // this.htCode = data.data.htCode;
      this.orders.invoicingResults=data.data.invoicingResults;
      switch (data.data.orders.orderStatus) {
        case "1":
          this.active = 1;
          break;
        case "5":
          this.active = 2;
          break;
        case "8":
          this.isrefund = true;
          this.active = 3;
          break;
        case "3":
          this.active = 2;
          break;
        case "4":
          this.active = 3;
          break;
      }
    });
  },
};
</script>

<style lang="less">
.van-panel {
  margin-top: 5px;
}

.van-card {
  background-color: #fff;
}

.total {
  text-align: right;
  padding: 10px;
}

.footer_btn {
  text-align: right;

  .van-button {
    margin-left: 10px;
  }
}
.address_detail {
  padding: 5px;
}
</style>
